// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_siteicon} from '../ui/use_siteicon';
import {Editor} from '../../../shared/editor/editor';
import {Spinner} from '../lib/spinner';
import {Link} from '../ui/link';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import styles from './relative_domains_banner.module.less';

interface i_relative_domain_info {
    domain: string;
    name: string;
}

const use_domain_relatives = (domain: string)=>{
    const [info, set_info] = useState<i_relative_domain_info[] | null>(null);
    const [loading, set_loading] = useState(false);
    useEffect(()=>{
        if (!domain)
            return;
        set_loading(true);
        fetch('/www_cms/get_domain_relatives?domain='
            +encodeURIComponent(domain)).then(res=>{
                if (res.relatives && !!res.relatives.length)
                    set_info(res.relatives);
                set_loading(false);
        }).catch(()=>{
            set_info(null);
            set_loading(false);
        });
    }, [domain]);
    return {info, loading};
};

interface i_relative_domain_card_props {
    domain: string;
    title: string;
}

const Relative_domain_card = (props: i_relative_domain_card_props)=>{
    const {title, domain} = props;
    const {theme} = useContext(Settings_context);
    const {icon_link, on_icon_error,
        on_icon_load} = use_siteicon({link: domain});
    return <Link className={styles.card} to={`/access/${domain}`}>
      <div className={styles.img_container}>
        <img src={icon_link} alt={`${domain} icon`} onError={on_icon_error}
          onLoad={on_icon_load} className="lazyload"/>
      </div>
      <p className={cn([theme.p3, theme.color_n700,
        theme.med, styles.card_title])}>
        {title}
      </p>
      <p className={theme.p4}>from anywhere</p>
    </Link>;
};

interface i_relative_domains_banner_props {
    domain: string;
    header?: string;
    subheader?: string;
}

const default_props: i_relative_domains_banner_props = {
    domain: '',
    header: 'Related Domains',
    subheader: 'Here are some related domains you might be interested in.',
};

export const Relative_domains_banner = (
props: i_relative_domains_banner_props)=>{
    const {theme} = useContext(Settings_context);
    const {header, subheader, domain} = {...default_props, ...props};
    const {info, loading} = use_domain_relatives(domain);
    return <div className={cn([theme.container, styles.container])}>
      <div className={styles.text_block}>
        <h3>{header}</h3>
        <p className={theme.u2}>{subheader}</p>
      </div>
      <div className={styles.cards_block}>
        {loading ? <Spinner small={true}/> :
          info && info.length > 0 ? info.map((d, i)=>
            <Relative_domain_card key={i} domain={d.domain} title={d.name}/>)
            : <p className={theme.p3}>No related domains found.</p>}
      </div>
    </div>;
};

interface i_relative_domains_banner_editor_props {
    value: i_relative_domains_banner_props;
    on_change: (new_val: i_relative_domains_banner_props)=>void;
}

export const Relative_domains_banner_editor = (
props: i_relative_domains_banner_editor_props)=>{
    const {value, on_change} = props;
    return <Editor value={value} on_change={on_change} editors={[
      {key: 'header', label: 'Header', type: 'text'},
      {key: 'subheader', label: 'Subheader', type: 'text'},
    ]}/>;
};
